import { useMemo } from 'react';
import { useFirstActivationDateMs } from '@atlassian/jira-tenant-context-controller/src/components/first-activation-date-ms/index.tsx';
import { isWithinLast } from '../../utils/is-within-last/index.tsx';

// Only runs the comparison once during the component's lifecycle.
export const useIsFirstActivationDateWithinLastMemo = (duration: Duration) => {
	const firstActivationDate = useFirstActivationDateMs();
	return useMemo(
		() => isWithinLast(duration)(firstActivationDate),
		[duration, firstActivationDate],
	);
};
